// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"13962854","125":"44af61e0","453":"6264690d"}[chunkId] + ".chunk.js";
};